export const ContentMetadata = [
  { label: "Category tag", value: "category_tag" },
  { label: "Grade bands", value: "grade_band" },
  { label: "School type", value: "school_type" },
  { label: "Demographics", value: "demographic_name" },
];
